import { Routes } from '@angular/router';
import { Login } from './components/login/login';
import { Agree } from './components/agree/agree';
import { AuditRequest } from './components/audit-request/audit-request';
// import { File } from './components/file/file';
import { Results } from './components/results/results';
import { Complete } from './components/complete/complete';
import { Landing } from './components/landing/landing';
import { AgriStats } from './components/agri/agri';
import { Notice } from './components/notice/notice';
import { TysonCargill } from './components/tyson/tyson';
import { CertifiedClass } from './components/certified/certified';
import { CourtDocs } from './components/court-docs/court-docs';
import { Contact } from './components/contact/contact';
import { ClaimFiling } from './components/claim-filing/claim-filing';


export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'landing' },
  { path: 'login', component: Login },
  { path: 'agree', component: Agree },
  // { path: 'file', component: File },
  { path: 'landing', component: Landing },
  { path: 'agri', component: AgriStats },
  { path: 'audit-request', component: AuditRequest },
  { path: 'complete', component: Complete },
  { path: 'results', component: Results },
  { path: 'notice', component: Notice },
  { path: 'tyson', component: TysonCargill },
  { path: 'certified', component: CertifiedClass },
  { path: 'court-docs', component: CourtDocs },
  { path: 'claim-filing', component: ClaimFiling },
  { path: 'contact', component: Contact },

  { path: '**', redirectTo: 'landing' },

];
